import { makeStyles } from '@material-ui/core'

const styles = ({ primaryColor, secondaryColor } = {}) =>
  makeStyles((theme) => {
    const infoContrastText = primaryColor
      ? theme.palette.getContrastText(primaryColor)
      : theme.palette.white
    const infoContrastTextMuted = primaryColor
      ? `${theme.palette.getContrastText(primaryColor)}99`
      : 'rgba(255,255,255,0.6)'

    return {
      root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '100%',
        backgroundColor: theme.palette.background.default,
      },
      header: {
        backgroundColor: primaryColor || theme.palette.primary.main,
        padding: theme.spacing(2, 3),
      },
      logo: {
        height: 32,
        display: 'block',
      },
      heroSection: {
        position: 'relative',
        zIndex: 0,
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(7, 3, 6),
        overflow: 'hidden',
        minHeight: 260,
      },

      alertContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1,
      },
      alertIconWrapper: {
        marginBottom: theme.spacing(2),
      },
      alertIcon: {
        color: theme.palette.common.black,
        width: 64,
        height: 64,
      },
      alertOops: {
        fontSize: 15,
        fontWeight: 700,
        color: theme.palette.common.black,
        marginBottom: theme.spacing(0.5),
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
      },
      alertTitle: {
        fontSize: 26,
        fontWeight: 800,
        color: theme.palette.common.black,
        marginBottom: theme.spacing(2),
      },
      alertDescription: {
        fontSize: 15,
        color: theme.palette.text.secondary,
        lineHeight: 1.6,
        maxWidth: 520,
      },
      infoSection: {
        position: 'relative',
        zIndex: 0,
        backgroundColor: primaryColor || theme.palette.primary.main,
        padding: theme.spacing(5, 4, 4),
        overflow: 'hidden',
        flexGrow: 1,
        flexShrink: 0,
      },
      infoTitle: {
        fontSize: 20,
        fontWeight: 700,
        color: infoContrastText,
        textAlign: 'center',
        marginBottom: theme.spacing(4),
        position: 'relative',
        zIndex: 1,
      },
      cardsContainer: {
        display: 'flex',
        gap: theme.spacing(2.5),
        justifyContent: 'center',
        position: 'relative',
        zIndex: 1,
        flexWrap: 'wrap',
      },
      card: {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2.5),
        flex: '1 1 200px',
        maxWidth: 260,
      },
      cardNumber: {
        fontSize: 28,
        fontWeight: 800,
        color: theme.palette.greenPantone,
        lineHeight: 1,
        marginBottom: theme.spacing(1),
      },
      cardTitle: {
        fontSize: 15,
        fontWeight: 700,
        color: infoContrastText,
        marginBottom: theme.spacing(1),
      },
      cardDivider: {
        width: 32,
        height: 3,
        backgroundColor: theme.palette.greenPantone,
        borderRadius: 2,
        marginBottom: theme.spacing(1.5),
      },
      cardText: {
        fontSize: 13,
        color: infoContrastTextMuted,
        lineHeight: 1.6,
      },
      hexTopLeft: {
        position: 'absolute',
        top: 0,
        left: 0,
        transform: 'rotate(180deg)',
        zIndex: -1,
        ...(secondaryColor && {
          '& path': { stroke: `${secondaryColor} !important` },
        }),
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },
      hexBottomRight: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        zIndex: -1,
        ...(secondaryColor && {
          '& path': { stroke: `${secondaryColor} !important` },
        }),
        [theme.breakpoints.down('md')]: {
          display: 'none',
        },
      },
      courseSection: {
        position: 'relative',
        zIndex: 1,
        marginTop: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      },
      courseHeading: {
        fontSize: 18,
        fontWeight: 700,
        color: infoContrastText,
        marginBottom: theme.spacing(3),
        maxWidth: 560,
      },
      courseCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2),
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(3),
        width: '100%',
        maxWidth: 360,
      },
      courseImage: {
        width: '100%',
        maxHeight: 180,
        objectFit: 'cover',
        borderRadius: theme.spacing(0.5),
        display: 'block',
      },
      courseName: {
        fontSize: 16,
        fontWeight: 700,
        color: infoContrastText,
      },
      courseButton: {
        backgroundColor: secondaryColor || theme.palette.greenPantone,
        color: theme.palette.white,
        fontWeight: 700,
        fontSize: 14,
        padding: theme.spacing(1.5, 4),
        borderRadius: theme.spacing(1),
        cursor: 'default',
        pointerEvents: 'none',
        userSelect: 'none',
      },
      footerText: {
        fontSize: 13,
        color: infoContrastTextMuted,
        textAlign: 'center',
        marginTop: theme.spacing(4),
        position: 'relative',
        zIndex: 1,
      },
    }
  })

export default styles
